import * as Constants from './Constants';

const initialState = {
  apiCompleted: false,
};

function cradleResponse(state = initialState, action) {
  switch (action.type) {
    case Constants.STORE_CRADLE_THROTTLE_VALUE: {
      return { ...state, cradleResponse: action.response, apiCompleted : true };
    }
    case Constants.CRADLE_API_INIT: {
      return { ...state, apiCompleted : false};
    }
    case Constants.CRADLE_API_COMPLETED: {
      return { ...state, apiCompleted : true};
    }
    default:
      return state;
  }
}

export default cradleResponse;
